// react libraries
import React, { useEffect, useState } from 'react';

// third-party libraries
import { Form, Button, Input } from 'antd';
import SpeechRecognition, {
  useSpeechRecognition,
} from 'react-speech-recognition';
import { AudioOutlined, AudioMutedOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

import './index.less';

const { TextArea } = Input;

const TextAreaWithMic = ({
  form,
  label,
  required,
  rules,
  name,
  autoSize,
  value,
  onChange,
  onBlur,
  placeholder,
  showExtraText,
  textAreaStyle,
}) => {
  const { transcript, listening, resetTranscript } = useSpeechRecognition();
  const [micField, setMicField] = useState('');

  useEffect(() => {
    if (micField === `${name}`) {
      form.setFieldsValue({
        [name]: transcript,
      });

      onChange && onChange({ target: { value: transcript } });
    }
  }, [transcript, name, micField]);

  useEffect(() => {
    value &&
      form.setFieldsValue({
        [name]: value,
      });
  }, [value]);

  useEffect(() => {
    // if the field is not null, then start listening
    if (micField === `${name}`) {
      resetTranscript();
      SpeechRecognition.startListening({ continuous: true });
    } else {
      SpeechRecognition.stopListening();
    }
  }, [micField]);

  return (
    <div className="speech-to-text-input-wrapper">
      <Form.Item
        name={name}
        label={label}
        required={required}
        rules={rules}
        extra={
          showExtraText && 'Click on the microphone icon and begin talking'
        }
      >
        <TextArea
          placeholder={placeholder}
          autoSize={autoSize || { minRows: 4, maxRows: 7 }}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          style={textAreaStyle}
        />
      </Form.Item>

      {micField === `${name}` ? (
        <Button
          type={'text'}
          shape={'default'}
          icon={<AudioMutedOutlined />}
          danger={true}
          size="small"
          className="record-button"
          onClick={() => {
            setMicField('');
          }}
          style={{
            bottom: showExtraText ? 34 : 6,
            right: showExtraText ? 13 : -4,
          }}
        >
          {listening && 'listening..'}
        </Button>
      ) : (
        <Button
          type={'primary'}
          shape={'circle'}
          className="record-button"
          icon={<AudioOutlined />}
          style={{
            bottom: showExtraText ? 34 : 6,
            right: showExtraText ? 13 : -4,
          }}
          size="small"
          danger={false}
          onClick={() => {
            setMicField(`${name}`);
          }}
        ></Button>
      )}
    </div>
  );
};

TextAreaWithMic.defaultProps = {
  showExtraText: true,
};

TextAreaWithMic.propTypes = {
  form: PropTypes.object.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string.isRequired,
  autoSize: PropTypes.object,
  rules: PropTypes.array,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  showExtraText: PropTypes.bool,
  textAreaStyle: PropTypes.object,
};

export default TextAreaWithMic;
